export default __webpack_public_path__ + "static/media/65.b2f2036a.gif";